import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

import useLanguage from "@/hooks/useLanguage";
import { SvgIcon } from "../SvgIcon";
import "./header.scss";
import { Dropdown, Space, Divider } from "antd";
import type { MenuProps } from "antd";
import { logOut } from "@/api/config";
import pubLink from "@/assets/svg/publink.svg";
import { useLocation } from "react-router-dom";
import { IS_MOBILE } from "@/utils/tool";
import { userAtom } from "@/store/user";
import { useRecoilValue } from "recoil";

const Header = (props: {
  showLogo?: boolean;
  title?: string;
  step?: number;
  isHideUser?: boolean;
  setStep?: (step: number) => void;
}) => {
  const { isHideUser, showLogo = true } = props;
  const { language, setLanguage } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const user = useRecoilValue(userAtom);
  const items: MenuProps["items"] = [
    {
      key: "personal",
      label: t("个人中心"),
    },
    {
      key: "quit",
      label: t("退出"),
    },
  ];

  /**
   * 切换语言
   */
  const onLanguage = () => {
    const value = language === "en" ? "zh" : "en";
    setLanguage(value);
  };

  const handleMenuClick = ({ key }) => {
    switch (key) {
      case "quit":
        localStorage.removeItem("user");
        logOut();
        navigate(
          `/login?goto=${encodeURIComponent(
            `${location.pathname}${location.search}`
          )}`
        );
        break;
      case "personal":
        navigate("/personal");
        break;
      default:
        break;
    }
  };

  /**
   * 去登录
   */
  const toLogin = () => {
    navigate(
      `/login?goto=${encodeURIComponent(
        `${location.pathname}${location.search}`
      )}`
    );
  };

  return (
    <div
      className="pay-head-1"
      style={IS_MOBILE ? { position: "fixed", top: 0, zIndex: 3 } : {}}
    >
      {showLogo && (props.step === 0 || !props.step) && (
        <img className="head-logo" src={pubLink} alt="" />
      )}
    </div>
  );
};

export default Header;
